import React, { useEffect, useState } from "react";
import { ReleaseViewModel, releaseAPI } from "../api/releaseAPI";
import ErrorDisplay from "../common/ErrorDisplay";
import LoadingDisplay from "../common/LoadingDisplay";
import { Link } from "react-router-dom";
import { Problem } from "../api/backendApi";
import DateDisplay from "../common/DateDisplay";

function ReleaseHistoryPage() {
  const [releases, setReleases] = useState<ReleaseViewModel[]>([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Problem | undefined>(undefined);

  useEffect(() => {
    async function loadReleases() {
      setLoading(true);
      const data = await releaseAPI.getReleases();

      if (data.ok) {
        setError(undefined);
        setReleases(data.value);
      } else {
        setError(data.problem);
      }

      setLoading(false);
    }
    loadReleases();
  }, []);

  return (
    <>
      <div className="main-container-title">
        <h1>Releases</h1>
        <ErrorDisplay error={error} />
      </div>
      <div className="main-container-content">
        <LoadingDisplay loading={loading} />
        {!loading && (
          <div className="overflow-auto">
            <table className="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {releases.length > 0 ? (
                  releases.map((r) => (
                    <tr key={r.name}>
                      <td>{r.name}</td>
                      <td>
                        released by {r.releaseBy} on{" "}
                        <DateDisplay date={r.releaseDate} />
                      </td>
                      <td>
                        <Link to={r.name}>Details</Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3}>No releases yet...</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}

export default ReleaseHistoryPage;
